import React                    from 'react';
import { Observe }              from 'rewire-core';
import {
  WithStyle,
  FormView,
}                               from 'rewire-ui';
import { Theme }                from '@material-ui/core/styles';
import DraggableResizableDialog from '../ui/DraggableResizableDialog';
import addOccupationDialogModel from './AddOccupationDialogModel';
import { withStyles }           from '../utility/styles';

const styles = (_theme: Theme) => ({
});

interface IAddOccupationDialogProps {
}

type AddOccupationDialogProps = WithStyle<ReturnType<typeof styles>, IAddOccupationDialogProps>;

class AddOccupationDialog extends React.PureComponent<AddOccupationDialogProps> {
  constructor(props: AddOccupationDialogProps) {
    super(props);
  }

  componentWillUnmount() {
    addOccupationDialogModel.reset();
  }

  renderDialogContents = React.memo((): JSX.Element => {
    return <Observe render={() => (
      <FormView form={addOccupationDialogModel.form} onSubmit={addOccupationDialogModel.actionFn('save')}>
        {addOccupationDialogModel.form.fields.map((field: any) =>
          <div key={field.name} className='content'>
            <field.Editor className='span1' />
          </div>
        )}
      </FormView>
    )} />;
  });

  render() {
    return <Observe render={() => (
      <DraggableResizableDialog defaultWidth='xs' DialogProps={{dialog: addOccupationDialogModel}} DraggableResizableBoxProps={{minWidth: '250px', minHeight: '285px'}}>
        <this.renderDialogContents />
      </DraggableResizableDialog>
    )} />;
  }
}

export default withStyles<IAddOccupationDialogProps>(styles, AddOccupationDialog);
